import { formatDate } from '@/shared/lib/date';

import { ChannelProgramDays } from '../../types';

export function getChannelProgramDayDate(day: ChannelProgramDays, lang: string): string {
    const date = new Date();

    if (day === 'Yesterday') {
        date.setDate(date.getDate() - 1);
    }

    if (day === 'Tomorrow') {
        date.setDate(date.getDate() + 1);
    }

    return formatDate(date, lang, { day: '2-digit', month: 'long' });
}
